<script>
import ListView from "@/arch/components/data-table/ListView";
import { mapActions, mapGetters } from "vuex";
import FacturacionTrackingComponent from "./components/FacturacionTrackingComponent";
import FacturacionFaturaComponent from "./components/FacturacionFaturaComponent";
import DataTableLinkText from "@/arch/components/data-table/columns/DataTableLinkText";
import DataTableTransformValueColumn from "@/arch/components/data-table/columns/DataTableTransformValueColumn";
import DataTableTransformLinkColumn from "@/arch/components/data-table/columns/DataTableTransformLinkColumn";
import { VUE_APP_DECIMALS, VUE_APP_COUNTRY, VUE_APP_API_URL } from "@/config";
import utils from "@/utils";
import axios from "axios";

export default {
  name: "ViewListFacturacion",
  extends: ListView,
  components: {
    FacturacionTrackingComponent,
    FacturacionFaturaComponent,
  },
  data() {
    return {
      namePage: this.$i18n.t("billing"),
      path: "facturacion",
      filterContent: () =>
        import("./components/FacturacionFiltersComponent.vue"),
      headerContent: () =>
        import("./components/FacturacionHeaderComponent.vue"),
      hideDefaultActions: true,
      addNew: false,
      dataProperties: {
        path: "facturacion",
        namePage: this.$i18n.t("billing"),
      },
      headers: [
        {
          text: this.$i18n.t("billingNumber"),
          align: "start",
          sortable: true,
          value: "INVOICE",
          component: DataTableLinkText,
          options: {
            to: { name: "BillingDetails" },
            field: "INVOICE",
            transform(value) {
              return value.replace("VE", "").trim();
            },
          },
        },
        {
          text: this.$i18n.t("order"),
          align: "start",
          sortable: true,
          value: "SALES_ORDER",
        },
        {
          text: this.$i18n.t("purchaseOrder"),
          align: "start",
          sortable: true,
          value: "CUSTOMER_PO",
        },
        {
          text: this.$i18n.t("billingDate"),
          align: "start",
          sortable: false,
          value: "DATE_BILLING",
          component: "DataTableDateOnlyColumn",
        },
        {
          text: this.$i18n.t("vencimientoDate"),
          align: "start",
          sortable: false,
          value: "DUE_DATE",
        },
        {
          text: this.$i18n.t("status"),
          align: "start",
          sortable: false,
          value: "STATUS_PAYMENT",
          component: DataTableTransformValueColumn,
          options: {
            transform: (item) => this.$i18n.t(item),
          },
        },
        {
          text: this.$i18n.t("totalValue"),
          align: "start",
          sortable: true,
          value: "PRICE",
          component: "DataTableCurrencyColumn",
          options: {
            prefix: "$USD",
            dynamicPrefix: "CURRENCY",
            decimals: VUE_APP_DECIMALS,
          },
        },
        this.validateCountryColumn(),
        this.validateCountryColumnFatura(),
      ],
      thisPage: "faturamento",
    };
  },
  computed: {
    ...mapGetters("facturacionStore", {
      getGoodList: "getList",
    }),
  },
  created() {
    this.saveAccessPage();
  },
  methods: {
    ...mapActions({
      setDataToList(dispatch) {
        return dispatch(this.getPathStore + "/setDataToList", {
          type: "sales",
        });
      },
    }),
    validateCountryColumn() {
      if (VUE_APP_COUNTRY == "EC") {
        return {
          text: this.$i18n.t("shippingLocation"),
          align: "start",
          sortable: false,
          value: "SHIPPING_INSTRUCTIONS",
        };
      }
      return {
        text: this.$i18n.t("shippingLocation"),
        align: "start",
        sortable: false,
        value: "SHIP_LOCATION",
      };
    },
    validateCountryColumnFatura() {
      if (VUE_APP_COUNTRY == "UY") {
        return {
          text: this.$i18n.t("acoes"),
          align: "start",
          sortable: false,
          value: "LINK_FATURA",
          component: DataTableTransformLinkColumn,
        };
      }
      return {};
    },
    async saveAccessPage() {
      let country = utils.loadCountry();
      let userid = utils.loadUserId();

      axios.post(`${VUE_APP_API_URL}venusa/saveAccessPage`, {
        UNIDADE_PAIS: country,
        USERID: userid,
        THISPAGE: this.thisPage,
        TOKEN: utils.loadToken(),
      });
    },
  },
};
</script>
